<template>
  <div>Edit Videos</div>
</template>

<script>
export default {};
</script>